import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoLeadingSpace]',
  standalone: true
})
export class NoLeadingSpaceDirective {
  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // If the input starts with a space or is only spaces
    if (value.trim() === '' && value !== '') {
      // Remove all spaces
      input.value = value.trim();
      
      // Stop propagation to prevent search event
      event.stopPropagation();
      event.preventDefault();
    }
  }
  
  // Also handle keydown to prevent spaces at the beginning
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    
    // If the key is a space and cursor is at position 0, or the input is empty
    if (event.code === 'Space' && (input.selectionStart === 0 || input.value === '')) {
      event.preventDefault();
    }
  }
}